



































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import _ from "lodash";
import { Employee, StaffSurveyCodeRequest } from "@/api";
import { VForm } from "@/common/vuetify_types";
import ImageOption from "@/components/image_input/ImageOption.vue";
import ImageInputMobile from "@/components/image_input/ImageInputMobile.vue";
import * as validation from "@/tool/validation";

@Component({
  components: {
    ImageOption,
    ImageInputMobile,
  },
})
class SendSurveyLinkForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() readonly formId!: number;

  selectedEmployees: number[] = [];
  loading = false;
  searchInput = null;
  employeesRules = [validation.requireAutoSelectNumber];
  requiredTextInput = [validation.requiredString];
  space_check = validation.noSpace;
  res: { errors: string[]; total: number } | null = null;

  created() {
    this.$store.dispatch("directory/loadAllEmployees");
  }

  get employees(): Employee[] {
    const empls = _.orderBy(this.$store.state.directory.employees, employee =>
      employee.firstName.toLowerCase(),
    );
    return empls.map((employee: Employee) => {
      return {
        ...employee,
        list: `${employee.firstName} ${employee.lastName} - ${employee.title} - ${employee.departmentAssignments[0].departmentName}`,
      };
    });
  }

  remove(employee: number) {
    for (let i = 0; i < this.selectedEmployees.length; i++) {
      const selectedEmployee = this.selectedEmployees[i];
      if (selectedEmployee === employee) {
        this.selectedEmployees.splice(i, 1);
      }
    }
  }

  async submit() {
    const isValid = this.form.validate();
    if (isValid) {
      try {
        const requestBody = {
          formId: this.formId,
          employeeIds: this.selectedEmployees,
        } as StaffSurveyCodeRequest;
        this.loading = true;
        this.res = null;
        const response = await this.$store.dispatch(
          "staffSurvey/sendStaffSurveyLink",
          {
            requestBody,
          },
        );
        this.res = response;
        this.loading = false;
        if (this.res?.errors?.length === 0) {
          this.$store.dispatch(
            "alert/success",
            "Survey link sent successfully",
          );
          this.close();
        }
      } catch (e) {
        if (e instanceof Error) {
          this.$store.dispatch("alert/error", e.message);
        }
        this.loading = false;
      }
    }
  }

  close() {
    this.form.reset();
    this.res = null;
    this.$emit("close");
  }

  get finalEmployees() {
    let employees = this.$store.state.directory.employees;
    employees = employees
      ? employees.filter((employee: Employee) => {
          if (this.selectedEmployees.includes(employee.id)) {
            return employee;
          }
        })
      : [];
    return employees.map((employee: Employee) => {
      return {
        ...employee,
        list: `${employee.firstName} ${employee.lastName} - ${employee.title} - ${employee.departmentAssignments[0].departmentName}`,
      };
    });
  }

  set finalEmployees(value) {
    if (!this.selectedEmployees.includes(value?.id)) {
      if (value?.id) {
        this.selectedEmployees.push(value.id);
      }
    }
  }
}

export default SendSurveyLinkForm;
